/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */

import { Box, Chip, Typography } from "@mui/material";
import { useNavigate, useRouteError } from "react-router-dom";
import { ROUTES } from "../globals/globals";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { isLoggedInSelector } from "../store/api/auth/selectors";

const ErrorPage = () => {
  const navigate = useNavigate();
  const error: any = useRouteError();
  const [counter, setCounter] = useState(5);
  const isLoggedIn = useSelector(isLoggedInSelector);

  useEffect(() => {
    if (isLoggedIn) {
      navigate(ROUTES.HOME.Path, { replace: true });
    }
  }, [isLoggedIn, navigate]);

  useEffect(() => {
    if (counter > 0) {
      const timer = setTimeout(() => {
        setCounter(counter - 1);
      }, 1000);
      return () => {
        clearTimeout(timer);
      };
    } else {
      navigate(ROUTES.HOME.Path);
    }
  }, [counter, navigate]);
  return (
    <>
      <main id="error-content">
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            minHeight: "100vh",
          }}
        >
          <Typography variant="h1" component="h5">
            404
          </Typography>
          <Typography variant="h6">The page you’re looking for doesn’t exist.</Typography>

          <Chip label={`Will auto back to home in ${counter} Sec.`} color="warning" onClick={() => navigate(ROUTES.HOME.Path)} />
        </Box>

        {error && (error.statusText || error.message) && (
          <p>
            <i>{error.statusText || error.message}</i>
          </p>
        )}
      </main>
    </>
  );
};

export default ErrorPage;
